import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export const useLogoStore = create()(
  immer((set, get) => ({
    logos: [],
    setLogos: (iLogos) =>
      set((state) => {
        state.logos = iLogos;
      }),
  }))
);
